<div class="">
    <!-- <div class="row"> -->
    <!-- <div class="col-md-12 min-vh-100 d-flex flex-column justify-content-center"> -->
    <button class="btn btn-danger btn-sm float-md-right" (click)="onNoClick()">close</button>
    <a href="./#/home"><img src="./assets/img/ros_logo.png" alt="" width="200px"></a>
    <div class="row">
        <div class="col-lg-6 col-md-8 mx-auto">

            <!-- form card login -->
            <div class="card rounded shadow shadow-sm">
                <div class="card-header">
                    <h3 class="mb-0">Login</h3>
                </div>
                <div class="card-body">
                    <form class="form" role="form" autocomplete="off" id="formLogin" novalidate="" method="POST">
                        <div class="form-group">
                            <label for="uname1">Username</label>
                            <input type="text" class="form-control form-control-lg " name="uname1" id="uname1" required="">
                            <div class="invalid-feedback">Oops, you missed this one.</div>
                        </div>
                        <div class="form-group">
                            <label>Password</label>
                            <input type="password" class="form-control form-control-lg " id="pwd1" required="" autocomplete="new-password">
                            <div class="invalid-feedback">Enter your password too!</div>
                        </div>
                        <div>
                            <label class="custom-control custom-checkbox">
                                      <input type="checkbox" class="custom-control-input">
                                      <span class="custom-control-indicator"></span>
                                      <!-- <span class="custom-control-description small text-dark">Remember me on this computer</span> -->
                                    </label>
                        </div>
                        <button type="submit" class="btn btn-info float-right" id="btnLogin">Login</button>
                    </form>
                </div>
                <!--/card-block-->
            </div>
            <!-- /form card login -->

        </div>
    </div>
    <!--/row-->

    <!-- </div> -->
    <!--/col-->
    <!-- </div> -->
    <!--/row-->
</div>
<!--/container-->